export const PRODUCT_CONTINUE_BUTTON = 'pdp.button.continue';
export const PRODUCT_CONTINUE_BUTTON_ARIAL_LOADING =
  'pdp.button.continue.loading';
